import { motion } from 'framer-motion';
import { Button } from '../../ui/button';
import { Info } from '@phosphor-icons/react';

export const AgeRestrictionModal = ({ message, onClose }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
      <motion.div 
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="bg-white rounded-2xl p-6 max-w-lg w-full shadow-2xl"
      >
        <div className="flex items-center gap-3 mb-4">
          <div className="w-12 h-12 rounded-full bg-[#FEF3C7] flex items-center justify-center">
            <Info className="w-6 h-6 text-[#F59E0B]" weight="duotone" />
          </div>
          <h3 className="text-lg font-bold text-[#0F172A]">Clinical Advisory</h3>
        </div>
        <p className="text-[#64748B] leading-relaxed mb-6">{message}</p>
        <Button onClick={onClose} className="w-full bg-[#5B21B6] hover:bg-[#4C1D95] rounded-xl h-11">
          Understood
        </Button>
      </motion.div>
    </div>
  );
};
